import { useSelector } from "react-redux";
import type { RootState } from "../../app/store";
import { useGetCurrentUserQuery } from "./auth.api";

/** Refreshes `/me` on app load so module access stays current without re-login. */
export function AuthSessionSync() {
	const isAuthenticated = useSelector(
		(state: RootState) => state.auth.isAuthenticated,
	);
	useGetCurrentUserQuery(undefined, { skip: !isAuthenticated });
	return null;
}
